"use client";

import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {cssInterop} from "nativewind";
import React from "react";
import {ActivityIndicator} from "react-native";

import {useColors} from "../../../hooks/useColors";

cssInterop(ActivityIndicator, {
    className: {target: "style", nativeStyleToProp: {color: true}}
});

const spinnerStyle = tva({});

const Spinner = React.forwardRef<
    React.ElementRef<typeof ActivityIndicator>,
    React.ComponentProps<typeof ActivityIndicator>
>(
    (
        {
            className,
            color: colorProp,
            focusable = false,
            "aria-label": ariaLabel = "loading",
            ...props
        },
        ref
    ) => {
        const colors = useColors();
        const color = colorProp || colors["--color-primary-600"];
        return (
            <ActivityIndicator
                ref={ref}
                aria-label={ariaLabel}
                focusable={focusable}
                {...props}
                className={spinnerStyle({class: className})}
                color={color}
            />
        );
    }
);

Spinner.displayName = "Spinner";

export {Spinner};
